export default __webpack_public_path__ + "static/media/section3-left.46fa5ccf.png";